export default "__VITE_ASSET__B9e3PIHr__"